/* unplugin-vue-components disabled */import { render } from "./RightStake.vue?vue&type=template&id=231fe097&scoped=true"
import script from "./RightStake.vue?vue&type=script&lang=js"
export * from "./RightStake.vue?vue&type=script&lang=js"

import "./RightStake.vue?vue&type=style&index=0&id=231fe097&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231fe097"]])

export default __exports__